// import { BankPortalModule } from './bank-portal/bank-portal.module';
/**Angular Imports */
import { AuthService } from './auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
// import { SignaturePadModule } from 'angular2-signaturepad';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
//import { ChartModule } from 'angular-highcharts';
// import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';

registerLocaleData(localeIn);

// Datepicker module
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTablesModule } from 'angular-datatables';

/**App-Module imports */
import { SystemCommonModule } from './system-common/system-common.module';
import { HomeModule } from './home/home.module';
//import { OfflineModule } from './offline/offline.module';
//import { QuotationModule } from './quotation/quotation.module';
//import { PolicyModule } from './policy/policy.module';
// import { LeadModule } from './lead/lead.module';
// import { FNAModule } from './fna/fna.module';
// import { CollateralModule } from './collateral/tcollateral.module';
// import { CustomerPortalModule } from './customer-portal/customer-portal.module';

//import { CollateralProductModule } from './collateral-product/collateral-product.module';

//import { ReCaptchaModule } from 'angular-recaptcha3';
import { AgentModule } from './agent/agent.module';
import { DocumentManagementModule } from './document-management/document-management.module';
import { PolicydetailsModule } from './policydetails/policydetails.module';
import { ProductionModule } from './production/production.module';
import { FinanceModule } from './finance/finance.module';
import { ClaimsModule } from './claims/claims.module';
import { CompensationModule } from './compensation/compensation.module';
import { GamificationModule } from './gamification/gamification.module';
import { HierarchyModule } from './hierarchy/hierarchy.module';
import { NotificationModule } from './Notifications/notification.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.modules';
import { AgentRelationModule } from './agentRelation/agentRelation.module';
/**
 * Service Import
 */
import { SettingService } from './system-common/services/setting.service';
import DatePicker from '@ui5/webcomponents/dist/DatePicker';
import DateTimePicker from '@ui5/webcomponents/dist/DateTimePicker';
import { DashboardModule } from './dashboard/dashboard.module';
import { ContestAndIncentiveDetailsModule } from './contest-and-incentive-details/contest-and-incentive-details.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

export function init_app(appLoadService: SettingService) {
  return () => appLoadService.init();
}
function onAppInit(): () => Promise<any> {
  return (): Promise<any> => {
    DateTimePicker.define();
    return DatePicker.define();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    BrowserAnimationsModule,
    NgSelectModule,
    // SignaturePadModule,
    // ChartsModule,
    AngularSignaturePadModule,
    // ChartModule,
    DataTablesModule,
    HttpClientModule,
    SystemCommonModule,
    HomeModule,
    //OfflineModule,
    AgentModule,
    DocumentManagementModule,
    PolicydetailsModule,
    ProductionModule,
    AgentRelationModule,
    FinanceModule,
    ClaimsModule,
    CompensationModule,
    NotificationModule,
    DashboardModule,
    ContestAndIncentiveDetailsModule,
    GamificationModule,
    HierarchyModule,
    AppRoutingModule,
    DragDropModule,
    // ReCaptchaModule.forRoot({
    //   invisible: {
    //     sitekey: '6LfZ3KocAAAAABTKsmhNQO2hKpKAJHbbpxc4XIFn',
    //   },
    //   normal: {
    //     sitekey: '6LfZ3KocAAAAABTKsmhNQO2hKpKAJHbbpxc4XIFn',
    //   },
    //   language: 'en',
    // }),
  ],
  providers: [
    SettingService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [SettingService],
      multi: true,
    },
    AuthService,
    { provide: String, useValue: 'dummy' },
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInit,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
